import type { SVGProps } from "react";
const SenecPictogramBroadband = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 9H9C10.3062 9 11.4175 9.83481 11.8293 11H14C15.3062 11 16.4175 11.8348 16.8293 13H34C34.5523 13 35 13.4477 35 14C35 14.5523 34.5523 15 34 15H17V18H29C29.5523 18 30 18.4477 30 19C30 19.5523 29.5523 20 29 20H17V23H27C27.5523 23 28 23.4477 28 24C28 24.5523 27.5523 25 27 25H17V28H29C29.5523 28 30 28.4477 30 29C30 29.5523 29.5523 30 29 30H17V33H34C34.5523 33 35 33.4477 35 34C35 34.5523 34.5523 35 34 35H16.8293C16.4175 36.1652 15.3062 37 14 37H11.8293C11.4175 38.1652 10.3062 39 9 39H2V35C2 34.4477 2.44772 34 3 34C3.55228 34 4 34.4477 4 35V37H9C9.55228 37 10 36.5523 10 36V12C10 11.4477 9.55228 11 9 11H4V30C4 30.5523 3.55228 31 3 31C2.44772 31 2 30.5523 2 30V9ZM12 35H14C14.5523 35 15 34.5523 15 34V14C15 13.4477 14.5523 13 14 13H12V35Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37 17C37 15.3431 38.3431 14 40 14C41.6569 14 43 15.3431 43 17C43 18.6569 41.6569 20 40 20C38.3431 20 37 18.6569 37 17ZM40 16C39.4477 16 39 16.4477 39 17C39 17.5523 39.4477 18 40 18C40.5523 18 41 17.5523 41 17C41 16.4477 40.5523 16 40 16Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30 24C30 21.7909 31.7909 20 34 20C36.2091 20 38 21.7909 38 24C38 26.2091 36.2091 28 34 28C31.7909 28 30 26.2091 30 24ZM34 22C32.8954 22 32 22.8954 32 24C32 25.1046 32.8954 26 34 26C35.1046 26 36 25.1046 36 24C36 22.8954 35.1046 22 34 22Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40 30C40 28.3431 41.3431 27 43 27C44.6569 27 46 28.3431 46 30C46 31.6569 44.6569 33 43 33C41.3431 33 40 31.6569 40 30ZM43 29C42.4477 29 42 29.4477 42 30C42 30.5523 42.4477 31 43 31C43.5523 31 44 30.5523 44 30C44 29.4477 43.5523 29 43 29Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramBroadband;
